import React, { useState } from 'react';
import {
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
  useColorStyle,
  useColorMode,
} from '@tonic-one/react';
import QuarantineTabPanel from './Quarantine';
import UserReportedEmails from './UserReportedEmails';
import RiskAi from './RiskAI';
import { useTranslation } from 'react-i18next';
import DataTrack from '../../components/DataTrack';
import { useLocation, useNavigate } from 'react-router-dom';
import { handleNavigate } from '@Utils/common';
import { OperationTabUrl } from './utils/constants';

enum OperationTab {
  Quarantine = 'quarantine',
  UserReportedEmails = 'userReportedEmails',
  RiskAi = 'correlatedIntelligence',
}

const Operation = React.memo(() => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation(['operations']);
  const location = useLocation();
  const navigate = useNavigate();
  const [index, setIndex] = useState<OperationTab>(() =>
    getTabFromPath(location.pathname)
  );

  return (
    <Tabs
      index={index}
      onChange={(index: OperationTab) => {
        setIndex(index);
        const url = getPathFromTab(index);
        handleNavigate(url);
        navigate(url);
      }}
      minHeight="inherit"
    >
      <TabList
        pt="12px"
        px="16px"
        borderBottom="1px solid"
        borderBottomColor={colorStyle.divider}
      >
        <Tab index={OperationTab.Quarantine}>{t('side.group.quarantine')}</Tab>
        <DataTrack type="Operations.Tab.EuqFeedback">
          <Tab index={OperationTab.UserReportedEmails}>
            {t('operations.tab.euq.title')}
          </Tab>
        </DataTrack>
        <Tab index={OperationTab.RiskAi}>{t('policy.filterName.riskAi')}</Tab>
      </TabList>
      <TabPanels display="flex" flexDirection="column" flex="1 1 auto">
        <TabPanel index={OperationTab.Quarantine} height="100%">
          {({ isSelected }: { isSelected: boolean }) =>
            isSelected && <QuarantineTabPanel />
          }
        </TabPanel>
        <TabPanel index={OperationTab.UserReportedEmails} height="100%">
          {({ isSelected }: { isSelected: boolean }) =>
            isSelected && <UserReportedEmails />
          }
        </TabPanel>
        <TabPanel index={OperationTab.RiskAi} height="100%">
          {({ isSelected }: { isSelected: boolean }) =>
            isSelected && <RiskAi />
          }
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
});

export default Operation;

function getTabFromPath(path: string): OperationTab {
  if (path.includes(OperationTabUrl.RiskAi)) {
    return OperationTab.RiskAi;
  } else if (path.includes(OperationTabUrl.UserReportedEmails)) {
    return OperationTab.UserReportedEmails;
  }
  return OperationTab.Quarantine;
}

function getPathFromTab(tab: OperationTab): OperationTabUrl {
  switch (tab) {
    case OperationTab.RiskAi:
      return OperationTabUrl.RiskAi;
    case OperationTab.UserReportedEmails:
      return OperationTabUrl.UserReportedEmails;
    default:
      return OperationTabUrl.Quarantine;
  }
}
